<template>
  <section class="home">
<div class="container">
    <div class="box">

        <div class="title">
            <span class="block"></span>
            <h1>Lilitha Mantini<span></span></h1>
        </div>

        <div class="role">
            <div class="block"></div>
            <p>Frontend developer.</p>
        </div>

    </div>
</div>
<!-- 
<a href="https://youtu.be/7d2XsPSjjjI" target="_blank"><footer>
    <div class="texto">
        <span>
            <i class="fab fa-youtube"></i>
             watch on youtube</span>
    </div>
</footer>
   </a> -->
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.home {
  background-image: url("https://www.itl.cat/pngfile/big/327-3274460_web-development.jpg");
  height: 100vh;
  background-repeat: no-repeat;
}


@import url('https://fonts.googleapis.com/css?family=Lato:300,400|Poppins:300,400,800&display=swap');
 * {
	 margin: 0;
	 padding: 0;
}
 body, html {
	 overflow: hidden;
}
 .container {
	 width: 100%;
	 height: 100vh;
	 
	 display: flex;
	 justify-content: center;
	 align-items: center;
}

.box{
  justify-content: center;
  align-content: center;
  align-items: center;
}

h1{
  font-size: 50px !important;
}

p{
  font-size: 20px !important;
}
 .container .box {
	 width: 350px;
	 height: 250px;
	 position: relative;
	 display: flex;
	 justify-content: center;
	 flex-direction: column;
}
 .container .box .title {
	 width: 100%;
	 position: relative;
	 display: flex;
	 align-items: center;
	 height: 50px;
}
 .container .box .title .block {
	 width: 0%;
	 height: inherit;
	 background: #d66b18;
	 position: absolute;
	 animation: mainBlock 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) forwards;
	 display: flex;
}
 .container .box .title h1 {
	 font-family: 'Poppins';
	 color: #fff;
	 font-size: 32px;
	 -webkit-animation: mainFadeIn 2s forwards;
	 -o-animation: mainFadeIn 2s forwards;
	 animation: mainFadeIn 2s forwards;
	 animation-delay: 1.6s;
	 opacity: 0;
	 display: flex;
	 align-items: baseline;
	 position: relative;
}
 .container .box .title h1 span {
	 width: 0px;
	 height: 0px;
	 -webkit-border-radius: 50%;
	 -moz-border-radius: 50%;
	 border-radius: 50%;
	 background: #d66b18;
	 -webkit-animation: load 0.6s cubic-bezier(0.74, 0.06, 0.4, 0.92) forwards;
	 animation: popIn 0.8s cubic-bezier(0.74, 0.06, 0.4, 0.92) forwards;
	 animation-delay: 2s;
	 margin-left: 5px;
	 margin-top: -10px;
	 position: absolute;
	 bottom: 13px;
	 right: -12px;
}
 .container .box .role {
	 width: 100%;
	 position: relative;
	 display: flex;
	 align-items: center;
	 height: 30px;
	 margin-top: -10px;
}
 .container .box .role .block {
	 width: 0%;
	 height: inherit;
	 background: #e91e63;
	 position: absolute;
	 animation: secBlock 2s cubic-bezier(0.74, 0.06, 0.4, 0.92) forwards;
	 animation-delay: 2s;
	 display: flex;
}
 .container .box .role p {
	 animation: secFadeIn 2s forwards;
	 animation-delay: 3.2s;
	 opacity: 0;
	 font-weight: 400;
	 font-family: 'Lato';
	 color: #fff;
	 font-size: 12px;
	 text-transform: uppercase;
	 letter-spacing: 5px;
}
 @keyframes mainBlock {
	 0% {
		 width: 0%;
		 left: 0;
	}
	 50% {
		 width: 100%;
		 left: 0;
	}
	 100% {
		 width: 0;
		 left: 100%;
	}
}
 @keyframes secBlock {
	 0% {
		 width: 0%;
		 left: 0;
	}
	 50% {
		 width: 100%;
		 left: 0;
	}
	 100% {
		 width: 0;
		 left: 100%;
	}
}
 @keyframes mainFadeIn {
	 0% {
		 opacity: 0;
	}
	 100% {
		 opacity: 1;
	}
}
 @keyframes popIn {
	 0% {
		 width: 0px;
		 height: 0px;
		 background: #d66b18;
		 border: 0px solid #ddd;
		 opacity: 0;
	}
	 50% {
		 width: 10px;
		 height: 10px;
		 background: #d66b18;
		 opacity: 1;
		 bottom: 45px;
	}
	 65% {
		 width: 7px;
		 height: 7px;
		 bottom: 0px;
		 width: 15px;
	}
	 80% {
		 width: 10px;
		 height: 10px;
		 bottom: 20px;
	}
	 100% {
		 width: 7px;
		 height: 7px;
		 background: #d66b18;
		 border: 0px solid #222;
		 bottom: 13px;
	}
}
 @keyframes secFadeIn {
	 0% {
		 opacity: 0;
	}
	 100% {
		 opacity: 0.5;
	}
}
 footer {
	 width: 350px;
	 height: 80px;
	 background: #d66b18;
	 position: absolute;
	 right: 0;
	 bottom: -80px;
	 display: flex;
	 justify-content: center;
	 align-items: center;
	 animation: top 0.8s forwards;
	 animation-delay: 4s;
}
 footer span {
	 display: flex;
	 align-items: center;
	 justify-content: center;
	 font-size: 12px;
	 color: #232323;
	 font-family: 'Poppins';
}
 footer span i {
	 margin-right: 25px;
	 font-size: 22px;
	 color: #232323;
	 animation: icon 2s forwards;
	 animation-delay: 4s;
	 opacity: 0;
}
 @keyframes top {
	 0% {
		 opacity: 0;
		 bottom: -80px;
	}
	 100% {
		 opacity: 1;
		 bottom: 0px;
	}
}
 @keyframes icon {
	 0% {
		 opacity: 0;
		 transform: scale(0);
	}
	 50% {
		 opacity: 1;
		 transform: scale(1.3) rotate(-2deg);
	}
	 100% {
		 opacity: 1;
		 bottom: 0px;
	}
}
 
</style>
